module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./BeanListView.js"));
	}, "BeanListView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=BeanListView!./src/pages/PunchClock/Bean/BeanList/BeanListView.js
// module id = 1265
// module chunks = 438